import InternalTransportBaseScreen from "../../../../mapping_tool/UpdateNodes/shared/internalTransport/InternalTransportBaseScreen";

export const InternalTransportBase = ({ modalData }: { modalData: any }) => (
  <InternalTransportBaseScreen modalData={modalData} gate="farm" variant="simulate" />
);
